import { Icon } from "./Icon";

export interface SelectOption { id: string; label: string; }

interface SelectProps {
  value: string;
  options: SelectOption[];
  onChange: (v: string) => void;
  /** "underline" (band, editorial) or "boxed" (toolbar/dense). */
  variant?: "underline" | "boxed";
  label?: string;
}

/** Minimal select with a Material chevron and no native arrow. */
export function Select({ value, options, onChange, variant = "underline", label }: SelectProps) {
  const boxed =
    "w-full appearance-none rounded-lg border border-outline-variant/60 bg-surface-container-lowest px-3 py-2 pr-8 font-body text-[12px] text-primary outline-none focus:border-secondary";
  const underline =
    "w-full appearance-none rounded-none border-0 border-b border-outline-variant bg-transparent px-0 py-2 pr-8 font-body text-[15px] text-primary outline-none focus:border-secondary";
  return (
    <div className="relative">
      <select
        aria-label={label}
        className={`lux ${variant === "boxed" ? boxed : underline}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((o) => (
          <option key={o.id} value={o.id}>
            {o.label}
          </option>
        ))}
      </select>
      <Icon
        name="keyboard_arrow_down"
        size={18}
        className="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 text-outline"
      />
    </div>
  );
}
